
const UsersTable = ({
  users,
  loading,
  currentUser,
  onPromote,
  onDemote
}) => {
  const getInitials = (firstName, lastName) => {
    return (firstName[0] + lastName[0]).toUpperCase();
  };

  const getActionButtons = (user) => {
    if (user._id === currentUser?._id) {
      return <span className="text-sm text-gray-500 italic">You</span>;
    }

    if (user.role === 'user') {
      return (
        <button
          className="px-3 py-1 text-sm bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
          onClick={() => onPromote(user)}
        >
          Make Admin
        </button>
      );
    } else {
      return (
        <button
          className="px-3 py-1 text-sm bg-orange-500 text-white rounded-lg hover:bg-orange-600 transition-colors"
          onClick={() => onDemote(user)}
        >
          Demote User
        </button>
      );
    }
  };

  if (loading) {
    return (
      <div className="bg-white rounded-xl shadow-lg p-8 text-center">
        <div className="w-8 h-8 border-4 border-gray-200 border-t-stanford-red rounded-full animate-spin mx-auto mb-2"></div>
        <p className="text-gray-600">Loading users...</p>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-xl shadow-lg overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-stanford-red text-white">
            <tr>
              <th className="px-4 py-3 text-left text-sm font-semibold">User</th>
              <th className="px-4 py-3 text-left text-sm font-semibold">Email</th>
              <th className="px-4 py-3 text-left text-sm font-semibold">Role</th>
              <th className="px-4 py-3 text-left text-sm font-semibold">Joined</th>
              <th className="px-4 py-3 text-left text-sm font-semibold">Promoted By</th>
              <th className="px-4 py-3 text-left text-sm font-semibold">Actions</th>
            </tr>
          </thead>
          <tbody>
            {users.length === 0 ? (
              <tr>
                <td colSpan="6" className="px-4 py-8 text-center">
                  <div className="text-gray-500">No users found</div>
                </td>
              </tr>
            ) : (
              users.map((user) => {
                const initials = getInitials(user.firstName, user.lastName);
                const fullName = `${user.firstName} ${user.lastName}`;
                const promotedBy = user.promotedBy
                  ? `${user.promotedBy.firstName} ${user.promotedBy.lastName}`
                  : '-';
                const joinDate = new Date(user.createdAt).toLocaleDateString();

                return (
                  <tr key={user._id} className="border-b border-gray-200 hover:bg-gray-50">
                    <td className="px-4 py-3">
                      <div className="flex items-center gap-3">
                        <div className="w-10 h-10 rounded-full bg-stanford-red text-white flex items-center justify-center font-medium">
                          {initials}
                        </div>
                        <div>
                          <div className="font-medium text-gray-800">{fullName}</div>
                          <div className="text-sm text-gray-500">
                            {user.position || 'No position'}
                          </div>
                        </div>
                      </div>
                    </td>
                    <td className="px-4 py-3 text-sm text-gray-700">{user.email}</td>
                    <td className="px-4 py-3">
                      <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${
                        user.role === 'admin' ? 'bg-purple-100 text-purple-800' :
                        user.role === 'auditor' ? 'bg-blue-100 text-blue-800' :
                        'bg-gray-100 text-gray-700'
                      }`}>
                        {user.role === 'admin' ? 'Admin' :
                         user.role === 'auditor' ? 'Auditor' :
                         'User'}
                      </span>
                    </td>
                    <td className="px-4 py-3 text-sm text-gray-700">{joinDate}</td>
                    <td className="px-4 py-3 text-sm text-gray-700">{promotedBy}</td>
                    <td className="px-4 py-3">{getActionButtons(user)}</td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default UsersTable;
